import React from "react";

type Props = {
    label?: string;
    className?: string;
    spinnerClassName?: string;
};

export default function LoadingInline({
    label = "読み込み中...",
    className = "flex items-center gap-2 p-4 text-slate-500",
    spinnerClassName = "h-4 w-4 animate-spin rounded-full border-2 border-slate-300 border-t-slate-600",
}: Props) {
    return (
        <div className={className} role="status" aria-live="polite">
            <div className={spinnerClassName} aria-hidden="true" />
            {label}
        </div>
    );
}
